export default __webpack_public_path__ + "static/122-d76ea0f48bbe3ad6ca4eb1e88f2d58ea.gif";